import { Components, Theme } from '@mui/material/styles';

export default function MuiCheckbox(theme: Theme): Components['MuiCheckbox'] {
  return {
    styleOverrides: {
      root: {
        transition: 'all .5s ease-in-out',
        color: theme.palette.sandShade4.main,
        '&:hover': {
          color: theme.palette.taigaTint1.main,
        },
        '&.Mui-checked': {
          color: theme.palette.taiga.main,
        },
      },
    },
  };
}
